import { render } from "./ModalCategoriaEditar.vue?vue&type=template&id=5267d93c"
import script from "./ModalCategoriaEditar.vue?vue&type=script&lang=js"
export * from "./ModalCategoriaEditar.vue?vue&type=script&lang=js"

import exportComponent from "/home/u551436692/domains/jurissearch.com/hbuilds/source/repository/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__